import React, {Component} from "react";
import "./UserInquiry.css";
import {FormattedMessage} from "react-intl";
import InquiryTable from "./InquiryTable/InquiryTable";
import axios from "axios";
import {GOOGLE_ANALYTICS_CODE, RESOURCE_BASE_URL} from "../../../configuration";
import AccountSideBar from "../UserProfile/AccountSideBar/AccountSideBar";
import InquirySideBar from "./InquirySideBar";
import InitialQuotationState from "../QuotationForm/InitialQuotationState";
import GoogleAds from "../../Common/GoogleAds/GoogleAds";
import UserProfileNavBar from "../UserProfile/UserProfileNavBar";
import ReactGA from "react-ga";

class UserInquiry extends Component {

    constructor(props) {
        super(props);
        this.state = {
            userId: this.props.userId,
            getInquiries : false
        };

        this.getUserInquiries = this.getUserInquiries.bind(this);
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (prevProps.userData !== this.props.userData) {
            this.setState({userId: this.props.userId});
        }
    }

    getUserInquiries = () => {
        this.setState({
            getInquiries : !this.state.getInquiries
        })
    };

    render() {
        ReactGA.initialize(GOOGLE_ANALYTICS_CODE);
        ReactGA.pageview(window.location.pathname + window.location.search);
        return (
            <div className="btn-width-userProfile">
                <div className="row collapse-user-profile-div responsive-userAddress-table-mobile">
                    <UserProfileNavBar userId={this.props.userId}
                                       userData={this.props.userData}
                                       />
                </div>

                <div className="quotation-content test-quotation-content">

                    <GoogleAds slot="696274611"/>
                    <div className="btn-width-userProfile width-set-user-inquiry">

                        <div
                            className="padding-15-user-inquiry no-padding-left  user-inquiry-content-width responsive-userAddress-table">

                            <div className="row">
                                <div className="col-md-2" id="inquiry-side-bar">
                                    <InquirySideBar user={this.props.user}
                                                    userData={this.props.userData}
                                                    getUserInquiries = {this.getUserInquiries}/>

                                </div>
                                <div className="col-md-10">
                                    <div className="spacer"></div>

                                    <div className="user-inquiry-div resp-user-inquiry-div">
                                        <div className="title-1 text-align-left">
                                            お問合せ履歴
                                        </div>
                                        <hr/>

                                        <InquiryTable
                                            userData={this.props.userData}
                                            userId={InitialQuotationState.loggedUserId}
                                            getInquiries={this.state.getInquiries}/>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="responsive-userAddress-table-mobile">

                            <div className="custom-col-12">
                                <div
                                    className="collapse-light-green  inquiry-list-height set-margin-user-profile-settings custom-col-12 text-center-responsive">
                                    <FormattedMessage id="app.inquiry-table.title"
                                                      defaultMessage="INQUIRIES"
                                                      description=""/>
                                </div>
                                <hr/>

                                <InquiryTable
                                    userData={this.props.userData}
                                    userId={InitialQuotationState.loggedUserId}/>

                            </div>
                        </div>

                    </div>
                </div>
            </div>
        )
    }
}

export default UserInquiry;



// WEBPACK FOOTER //
// ./src/components/Site/UserInquiry/UserInquiry.js